import { render } from "./CtaRepair.vue?vue&type=template&id=2a9c9a07"
import script from "./CtaRepair.vue?vue&type=script&lang=js"
export * from "./CtaRepair.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__